 gsap.registerPlugin(ScrollTrigger, SplitText);

const fadeUpElements = document.querySelectorAll("section .fade-up, footer .fade-up");

if(fadeUpElements.length) {
  gsap.from(fadeUpElements, {
    opacity: 0,
    y: 100,
    scale: 0.8,
    duration: 1.5,
    ease: "power2.out",
    stagger: 0.1,
    scrollTrigger: {
      trigger: fadeUpElements[0].closest('section, footer'),
      start: "top center",
      toggleActions: "play none none none"
    }
  });
}

 


document.querySelectorAll(".reveal-text").forEach((element) => {

  const split = new SplitText(element, {
    type: "chars"
  });

  const  triggerElement  = element.closest('.reveal-inner');

  const chars = split.chars;

  if(triggerElement != null){
    
  gsap.fromTo(
    chars,
    {
      y: 10,
    opacity: 0.3,
    duration: 0.8
    },
    {
      opacity: 1,
      stagger: 0.02,
      scrollTrigger: {
        trigger: triggerElement,
        start: "top 80%",
        end: "top 20%",
        scrub: true,
      }
    }
  );

   }

});



const promoTrigger = document.querySelector('.collection-promo-animate');
const promoItems   = document.querySelectorAll('.collection-promo-fade-up');

if (promoTrigger && promoItems.length) {
  gsap.from(promoItems, {
    scrollTrigger: {
      trigger: promoTrigger,
      start: 'top 90%',
    },
    opacity: 0,
    y: 50,
    duration: 2,
    ease: 'power2.out',
    stagger: 0.2,
  });
}


window.addEventListener('resize', () => {
  ScrollTrigger.refresh();
});